import gql from 'graphql-tag'

export const GET_IMAGES = gql`
    query GetImages {
        objectsConnection {
            aggregate {
                count
            }
        }
        images {
            id
            originalName
            # seoName
            mimetype
            extension
            metadata {
                size
                space
                width
                height
                format
                density
                channels
                hasAlpha
                hasProfile
                orientation
                isProgressive

            }
            bucket {
                location,
                bucket,
                key,
                etag,
                size
            }
        }
    }
    
`

export const GET_IMAGE = gql`
    query GetImage($id: String!) {
        image(id: $id) {
            id
            originalName
            # seoName
            mimetype
            extension
            metadata {
                size
                space
                width
                height
                format
                density
                channels
                hasAlpha
                hasProfile
                orientation
                isProgressive

            }
            bucket {
                location,
                bucket,
                key,
                etag,
                size
            }
        }
    }
    
`

export const GET_IMAGE_COUNTS = gql`
    query GetImageCounts {
        objectsConnection {
            aggregate {
                count
                storage
                bandwidth
            }
        }
    }
`

export const GET_OBJECTS = gql`
    query GetObjects {
        objectsConnection{
            aggregate {
                count
            }
        }
        objects {
            id
            seoName
            
            account {
                id
            }
            image {
                id
                originalName
                mimetype
                extension
                metadata {
                    width
                    height
                }
            }
        }
    }
`

export const CREATE_STORAGE_ALIAS = gql`
    mutation CreateStorageAlias($data: AliasInput!) {
    createStorageAlias(data: $data) {
        alias
        directory
    }
}
`

export const GET_STORAGE_ALIASES = gql`
    query GetStorageAliases {
        storageAliases {
            alias
            directory
        }
    }
`

export const DELETE_OBJECT = gql`
    mutation DeleteObject($data: ObjectInput!) {
        deleteObject(data: $data) {
            id
        }
    }
`

export const SOURCE_STATUS = gql`
    query SourceStatus($url: String!) {
        sourceStatus(url: $url) {
            status
        }
    }
`


// WEBPACK FOOTER //
// ./src/operations/Object/index.js